import React, { useEffect, useState } from "react";
import UsersListController from "./controllers/users-list/users-list-controller";
import UserPermissionController from "./controllers/user-permission/user-permission-controller";
import DataCollectionsController from "./controllers/data-collections/data-collections-controller";
import AddNewUserController from "./controllers/users-list/add-new-user-controller";
import { AddNewConnection } from "./controllers/connections/add-new-connection/add-new-connection";
import { ConnectionsList } from "./controllers/connections/connections-list/connections-list";
import { Connections } from "./controllers/connections/connections";
import { Layout } from "./controllers/layout/layout";
// import { LoginSignUp } from "./components/login-signup/login-signup";
import LoginController from "./controllers/login/login";
import SignupController from "./controllers/signup/signup";

import GroupsController from './controllers/group-subgroups/groups-controller';

import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AddNewDataCollection } from "./controllers/data-collections/add-new-data-collection/add-new-data-collection";
import { DataCollectionsOutlet } from "./controllers/data-collections/data-collections-outlet";
import UsersPermissionForCollectionController from "./controllers/data-collections/users-permission-for-collection/users-permission-for-collection-controller";
import { getToken, setToken } from "./shared/local-storage-handler/local-storage-handler";
import ChangePassword from "./controllers/header-username-menu/changePassword/ChangePassword";
import AcceptInvitation from "./controllers/connections/acceptInvitation/accept-Invitation";
import VariablesPopup from "./controllers/connections/variables/variables-Popup";
import Variables from "./controllers/connections/variables/variables-controller";
import BeginOAuth from "./components/auth-callback/begin-oauth";
import AuthCallback from "./components/auth-callback/auth-callback";
import ForgetPasswordController from "./controllers/forget-password/forget-password";

import Checkout from "./controllers/checkout-process/checkout/Checkout";
import OrderCompleteController from "./controllers/order-complete/order-complete";

import useAppTitle from "./components/app-title/app-title";
import { Settings } from "./components/settings/settings";
import PageNotFoundController from "./controllers/page-not-found/page-not-found-controller";

import { AddNewConnectionExcel } from "./controllers/connections/add-new-connection-excel/add-new-connecton-excel";
import LayoutExcel from "./controllers/layout-excel/layout-excel";
import DataVisualizerController from "./controllers/data-collections/DataVisualizer/data-visualizer-controller";

// import PluginParameter from "./components/asheetPlugin/plugin-parameters/plugin-parameters";
import PluginController from "./controllers/asheetPlugin/plugin/pluginController";
import AsheetPlugInHeader from "./controllers/asheetPlugin/asheetLayout/asheet-plugin-header";
// import StartingPageContoller from "./controllers/asheetPlugin/starting-page/starting-page";
import AddConnectionContoller from "./controllers/asheetPlugin/add-connections/add-connection";
import OpenDirect from "./controllers/open-direct/open-direct";
import PluginParameterController from "./controllers/asheetPlugin/plugin-parameter/plugin-parameter";
import ExternalSignIn from "./controllers/external-signin/external-signin";
import { AppEnum } from "./constants/app-enum";
import jwtDecode from "jwt-decode";
import UnauthorizedResourceController from "./controllers/unauthorized-resource/unauthorized-resource-controller";
import DataScriptController from "./controllers/data-collections/data-script/data-script";
import AddNewDataScriptController from "./controllers/data-collections/data-script/add-new-data-script";
import { DataScriptOutlet } from "./controllers/data-collections/data-script-outlet";
import UserAccessLogController from "./controllers/user-access-log/user-access-log-controller";
import UserAPIkeyController from "./controllers/user-api-key/user-api-key-Controller";

import NativeDataVisualizerController from "./controllers/data-collections/NativeDataVisualizer/native-data-visualizer-controller";
import serverFunctions from "./components/asheetPlugin/utils2/serverFunctions";
import { getTokenWithIdToken } from "./services/login-signup.service";
import { setSessionStorageItem } from "./shared/session-storage-handler/session-storage-handler";
import jwt from 'jwt-decode'
import { CircularProgress } from "@mui/material";
export const ProtectedRoute = ({ children }) => {
  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export const RoleBasedAuthorization = ({ children }) => {
  let userRole = "";

  const location = useLocation();

  const aSTenantId = sessionStorage.getItem('ASTenantId') || localStorage.getItem('ASTenantId');
  // aSTenantId = localStorage.getItem('ASTenantId');
  const decodedToken = jwtDecode(getToken());

  const tenantList = JSON.parse(decodedToken?.tenants);

  if (aSTenantId) {
    const selectedTenant = tenantList?.find(item => item.ASTenantId === aSTenantId);
    if (selectedTenant) {
      userRole = selectedTenant.UserRoleId;
    }
  }

  const routes = AppEnum.Routes;

  const currentRoute = routes.find(r => location.pathname.includes(r.path));

  if (currentRoute?.userRoleIds.includes(userRole)) {
    return children;
  }

  return <Navigate to="/unauthorized-resource" replace state={{ from: location.pathname }} />;
}

export const AgencyClientBasedAuthorization = ({ children }) => {
  const location = useLocation();

  const aSTenantId = sessionStorage.getItem('ASTenantId') || localStorage.getItem('ASTenantId');

  const decodedToken = jwtDecode(getToken());
  const ownerTenantUId = decodedToken?.ASTenantUId;

  if (decodedToken.AgencyUId && ownerTenantUId != aSTenantId) {
    const tenantList = JSON.parse(decodedToken?.tenants);

    if (aSTenantId){
        const selectedTenant = tenantList?.find(item => item.ASTenantId === aSTenantId);
              if (selectedTenant) {
                  if (selectedTenant.AgencyUId) {
                    return <Navigate to="/unauthorized-resource" replace state={{ from: location.pathname }}/>;
                  }
              }
    }

  }
  return children;
}

const GoogleSheetPluginAuthorization = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const authenticate = async () => {
      try {
        if (!getToken()) {
          const payload = {
            grantType: 'id_token',
            idToken: await serverFunctions.getAuthIdToken()
          };
          const response = await getTokenWithIdToken(payload);

          setToken("token", response?.data?.access_token);
          setToken("refresh_token", response?.data?.refresh_token);
          
          if (response?.data?.access_token) {
            let decodedToken = jwt(response?.data?.access_token);
            if (decodedToken?.ASTenantUId) {
              setToken("ASTenantId", decodedToken?.ASTenantUId);
              setSessionStorageItem("ASTenantId", decodedToken?.ASTenantUId);
            }
            setIsAuthenticated(true);
          }
        } else {
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error("Authentication failed:", error);
        // Handle error appropriately
      } finally {
        setIsLoading(false);
      }
    };

    authenticate();
  }, []);

  if (isLoading) {
    return   <CircularProgress
    className={`circularLoader`}
    thickness={4}
    size={50}
/>
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};



const AppRouting = () => {

  const location = useLocation();
  const [getTitle] = useAppTitle();

  useEffect(() => {
    getTitle() //calling hook to dynamically change the app title
  }, [location.pathname]);

  let routes = (
    <Routes>
      <Route path="/connections/add-connection-excel"
        element={<ProtectedRoute>
          <LayoutExcel />
          <AddNewConnectionExcel />
        </ProtectedRoute>}>
      </Route>

      <Route path="/plugin" element={
        <GoogleSheetPluginAuthorization>
          <AsheetPlugInHeader />
         </GoogleSheetPluginAuthorization>
      }>
        <Route path="/plugin" element={<PluginController />} />
        <Route path="/plugin/add-connection" element={<AddConnectionContoller />} />
        <Route path="/plugin/data-collections/:collectionUId" element={<PluginParameterController />} />
      </Route>

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >

        <Route path="/connections" element={<Connections />}>
          <Route path="/connections" element={<ConnectionsList />} />

          <Route
            path="/connections/add-connection"
            element={<RoleBasedAuthorization>
              <AddNewConnection />
            </RoleBasedAuthorization>}
          />
          <Route
            path="/connections/edit-connection/:datasourceId"
            element={<RoleBasedAuthorization>
              <AddNewConnection />
            </RoleBasedAuthorization>}
          />


        </Route>


        <Route path="/groups" element={<GroupsController />} />


        <Route path="/user-access-log" element={<UserAccessLogController />} />


        <Route
          path="/book-an-expert"
          element={<RoleBasedAuthorization>
            <Checkout pFlag={"BUY"} />
          </RoleBasedAuthorization>}
        />

      <Route
        path="/update-checkout"
        element={<RoleBasedAuthorization> 
                    <AgencyClientBasedAuthorization>
                        <Checkout pFlag={"update"} />
                    </AgencyClientBasedAuthorization>
                  </RoleBasedAuthorization> }
      />

        <Route path="/variables" element={<RoleBasedAuthorization>
          <Variables />
        </RoleBasedAuthorization>}
        />
        <Route
          path="/variables/add-new-variables-popup"
          element={<VariablesPopup />}
        />
        <Route
          path="/variables/update-variable/:variableUId"
          element={<VariablesPopup />}
        />
        <Route path="/settings" element={<Settings />} />
        <Route path="/changepassword" element={<ChangePassword />} />


        <Route path="/users" element={<UsersListController />} />

        <Route
          path="/users/user-permission"
          element={
            <RoleBasedAuthorization>
              <UserPermissionController />
            </RoleBasedAuthorization>
          }
        />
        <Route path="/users/add-new-user" element={<AddNewUserController />} />

        <Route path="/data-collections" element={<DataCollectionsOutlet />}>
          <Route
            path="/data-collections"
            element={<DataCollectionsController />}
          />
          <Route
            path="/data-collections/add-new-data-collection"
            element={<RoleBasedAuthorization>
              <AddNewDataCollection />
            </RoleBasedAuthorization>}
          />
          <Route
            path="/data-collections/update-collection/:collectionUId"
            element={<RoleBasedAuthorization>
              <AddNewDataCollection />
            </RoleBasedAuthorization>}
          />

          <Route
            path="/data-collections/user-permissions/:collectionUId"
            element={<RoleBasedAuthorization>
              <UsersPermissionForCollectionController />
            </RoleBasedAuthorization>}
          />

        </Route>
        <Route path="/data-script" element={<DataScriptOutlet />}>
          <Route
            path="/data-script"
            element={<DataScriptController />}
          />
          <Route
            path="/data-script/add-new-data-script"
            element={<AddNewDataScriptController />}
          />
          <Route
            path="/data-script/update-data-script/:scriptUId"
            element={<AddNewDataScriptController />}
          />
        </Route>

        <Route
              path="/api-key"
              element={<UserAPIkeyController />}
        />

        <Route path="/" element={<Navigate replace to="/connections" />} />
      </Route>

      <Route path="/login" element={<LoginController pFlag={"login"} />} />
      <Route path="/signup" element={<SignupController pFlag={"signup"} />} />

      <Route path="/begin-oauth" element={<BeginOAuth />} />
      <Route path="/auth-callback" element={<AuthCallback />} />

      {/* it is used for checkout process */}
      <Route path="/checkout" element={<Checkout />} />

      <Route path="/order-complete" element={<OrderCompleteController />} />

      <Route path="/forgotpassword" element={<ForgetPasswordController pFlag={"forgotpassword"} />} />
      <Route path="/resetpassword" element={<ForgetPasswordController pFlag={"resetpassword"} />} />

      <Route path="/acceptinvitation" element={<AcceptInvitation />} />
      <Route path="/page-not-found" element={<PageNotFoundController />} />
      <Route path="/collection/data-visualizer" element={<DataVisualizerController />} />
      <Route path="/collection/native-data-visualizer" element={<NativeDataVisualizerController />} />
      <Route path="/open-direct" element={<OpenDirect />} />
      <Route path="/plugin/data-collections/:collectionUId" element={<PluginParameterController />} />
      <Route path="/login-jwt-auth" element={<ExternalSignIn />} />
      <Route path="*" element={<Navigate replace to="/page-not-found" />} />
      <Route path="/unauthorized-resource" element={<UnauthorizedResourceController />} />
    </Routes>
  );

  return <React.Fragment>{routes}</React.Fragment>;
};

export default AppRouting;
